import { render } from "./MyStoreMenu.vue?vue&type=template&id=4944c0f6&scoped=true"
import script from "./MyStoreMenu.vue?vue&type=script&lang=ts"
export * from "./MyStoreMenu.vue?vue&type=script&lang=ts"

import "./MyStoreMenu.vue?vue&type=style&index=0&id=4944c0f6&lang=scss&scoped=true"
import "./MyStoreMenu.vue?vue&type=style&index=1&id=4944c0f6&lang=scss"
script.render = render
script.__scopeId = "data-v-4944c0f6"

export default script